import { atomWithSession } from '@/utils/sessionStorageAtom';

export const screenerAllFacilitiesSelectedLastValueAtom =
  atomWithSession<boolean>('screenerAllFacilitiesSelectedLastValue', false);
